import styles from '@/styles/sliderBarLeft.module.scss'
import Link from 'next/link'
import Image from 'next/image'
import { useEffect, useState } from 'react'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
const apiDomain = publicRuntimeConfig.apiDomain

export default function SliderBarLeft() {
  const [email, setEmail] = useState('')
  const [imgUrl, setImgUrl] = useState("")

  useEffect(()=> {
    const localImgUrl = sessionStorage.getItem('subscribeImageUrl')
    if (localImgUrl) {
      setImgUrl(localImgUrl)
    } else {
      const defaultImgUrl = `${imageDomain}/subscribe-190x564.png?t=${new Date().getTime()}`
      setImgUrl(defaultImgUrl)
      sessionStorage.setItem('subscribeImageUrl', defaultImgUrl)
    }
  }, [])

  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
  }

  // 提交newsletters
  const handleSubmit = () => {
    let url = '/newsletters?email='
    if (email) {
      url += email
    } else {
      url += 'Email+Address'
    }

    window.location.href = url
  }

  function handlePageJump(url: string, e: any) {
    // 阻止a标签默认行为
    e.preventDefault()
    window.location.href = `${url}`
  }

  return (
    <div className={styles['slider-bar-left']} id="sliderBarLeft">
      <Link href='/newsletters' legacyBehavior>
        <a onClick={(e: any) => handlePageJump(`${apiDomain}/newsletters`, e)}>
          <Image
            className={styles['main-img']}
            src={imgUrl}
            alt="Subscribe"
            priority={true}
            width={95}
            height={282}></Image>
        </a>
      </Link>
      <div className={styles['form-box']}>
        <input
          className={styles['email-input']}
          placeholder="Email Address" 
          value={email}
          onChange={handleEmailChange}
        />
        <div className={styles['submit-btn']} onClick={handleSubmit}>Subscribe</div>
      </div>
    </div>
  )
}